import React from 'react'
import { Label } from 'spa/member/components/Label'
import { Input } from 'spa/member/components/Input'
import { InputFormProps } from './types'

export const StyledInputForm: React.FC<InputFormProps> = (props: InputFormProps) => {
  const badge = props.withBadge
  ? props.inputProps?.required
    ? 'REQUIRED'
    : 'OPTIONAL'
  : undefined;
  return (
    <div className="w-full" data-cy={props.dataCy}>
      <Label {...props.labelProps} htmlFor={props.name} label={props.label} badge={badge} />
      <Input
        {...props.inputProps}
        id={props.name}
        name={props.name}
        inputSize='small'
        rules={props.rules}
      />
    </div>
  )
}
